import { render } from "./LabelLocation.vue?vue&type=template&id=a98a00f4&scoped=true"
import script from "./LabelLocation.vue?vue&type=script&lang=js"
export * from "./LabelLocation.vue?vue&type=script&lang=js"

import "./LabelLocation.vue?vue&type=style&index=0&id=a98a00f4&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98a00f4"]])

export default __exports__